/**
 * Mode Context
 * Centralizes mock/real mode state across the application
 */

import React, { createContext, useContext, ReactNode, useState, useEffect } from 'react';

interface ModeContextType {
  isMock: boolean;
  isReal: boolean;
  mode: 'mock' | 'real';
}

const ModeContext = createContext<ModeContextType | undefined>(undefined);

export const ModeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isMock, setIsMock] = useState(false);
  const [isReal, setIsReal] = useState(false);
  const [mode, setMode] = useState<'mock' | 'real'>('real');

  useEffect(() => {
    const useMockFromEnv = import.meta.env.VITE_USE_MOCK_SERVER === 'true';
    const actualMode: 'mock' | 'real' = useMockFromEnv ? 'mock' : 'real';
    
    
    setMode(actualMode);
    setIsMock(actualMode === 'mock');
    setIsReal(actualMode === 'real');
  }, []);

  return (
    <ModeContext.Provider value={{ isMock, isReal, mode }}>
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = () => {
  const context = useContext(ModeContext);
  if (context === undefined) {
    throw new Error('useMode must be used within a ModeProvider');
  }
  return context;
};
